import { Component } from 'react';
import { Icon, Text } from '@blueprintjs/core';

export type LegendProps = Readonly<{
  text?: string;
  stroke: string;
}>;

export class Legend extends Component<LegendProps> {
  public render() {
    const { stroke, text } = this.props;

    return (
      <>
        <Icon
          icon="symbol-square"
          iconSize={16}
          title={null}
          color={stroke}
          className="Icon"
          style={{ cursor: 'default' }}
        />
        <Text ellipsize tagName="span" className="LegendText">
          {text}
        </Text>
      </>
    );
  }
}
